import { get } from 'lodash/get'
import { handleError } from 'helper/rest'
import { clientPublic } from 'helper/axios'

export const getResultSupportNeed = async ({
  project_id,
  sprintflow_id,
  taskinbox,
  token,
}) => {
  try {
    return await clientPublic
      .get(
        `supportneed?project_id=${project_id}&sprintflow_id=${sprintflow_id}&taskinbox=${taskinbox}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

export const getListSupportNeedByProjectId = async ({ id, token }) => {
  try {
    return await clientPublic
      .get(`supportneed?project_id=${id}&limit=99`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

export const addSupportNeed = async ({ params, token }) => {
  try {
    return await clientPublic
      .post(`supportneed`, params, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

export const getResultOptionSupportNeed = async ({ company_id, token }) => {
  try {
    return await clientPublic
      .get(`supporttype?company_id=${company_id}&limit=99`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

export const deleteSupportNeed = async ({
  project_id,
  params,
  supportneed_id,
  token,
}) => {
  try {
    return await clientPublic
      .delete(`supportneed/${supportneed_id}?project_id=${project_id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },

        data: params,
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

export const updateSupportNeed = async ({ supportneed_id, params, token }) => {
  try {
    return await clientPublic
      .put(`supportneed/${supportneed_id}`, params, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

export const updateStatusSupportNeed = async ({ supportneed_id, params, token }) => {
  try {
    return await clientPublic
      .put(`supportneed/${supportneed_id}/status`, params, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

export const sendMailSupportNeed = async ({ supportneed_id, params, token }) => {
  try {
    return await clientPublic
      .post(`supportneed/${supportneed_id}/sendmail`, params, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}
